export default __webpack_public_path__ + "static/burgerBot-1f0b6f4a3b04e86ee44ddec4fea6cb15.png";